(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('pharmaPortalApp')
        .constant('VERSION', "1.0.7")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
